import styled, { keyframes } from "styled-components";

const animation = keyframes`
  0% {
    opacity: 0;
    transform: translateX(8px);
  }

  100% {
    opacity: 1;
    transform: translateX(0px);
  }
`

const ConversationMessages = styled.div`
  padding: 24px 20px 0px;
  display: flex;
  flex-flow: wrap;
  transition: transform 200ms;
  overflow-anchor: none;
  opacity: 1;
  animation-name: ${animation};
  animation-duration: 320ms;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
  animation-delay: 230ms;
  animation-fill-mode: backwards;
`

export default ConversationMessages